module.exports = __webpack_public_path__ + "img/orav_1kl.b75c350a.jpg";